export default {
  namespaced: true,
  pacom: {
    pacom: "pacom",
    masterAccounts: "contas principais",
    masterAccount: "conta principal",
    first_name: "primeiro nome",
    last_name: "sobrenome",
    link: "link",
    username: "nome de usuário",
    token: "token",
    password: "senha",
    token_expired: "expiração do token",
    email: "email",
    sites: "sites",
    site: "site",
    name: "nome",
    description: "descrição",
    address: "endereço",
    latitude: "latitude",
    longitude: "longitude",
    timeZone: "fuso horário",
    profile: "perfil",
    calendar: "calendário",
    serialNumber: "número de série",
    actions: "ações",
    schemaTypes: "tipos de esquema",
    display_name: "nome de exibição",
    id: "id",
    devices: "dispositivos",
    schema_actions: "delinear ações",
    typeAlarm: "tipo de alarme",
    typeAlarms: "tipos de alarme",
    priority: "prioridade",
    dispatchAlarm: "disparar alarme",
    alarms: "alarme",
    state: "estado",
    creation_time: "fecha de creación",
    units: "unidades",
    center: "centro",
    sector: "sector",
    device: "dispositivo",
    schemaEvent: "tipo evento",
    time: "hora",
    type: "tipo",
    logs: "logs",
    resources: "recursos",
    id: "id",
    idAlarm: "id alarme",
    color: "color",
    status: "estado"
  }
}
